import { render, staticRenderFns } from "./officerComingSoon.vue?vue&type=template&id=8538b6d4&scoped=true"
import script from "./officerComingSoon.vue?vue&type=script&lang=js"
export * from "./officerComingSoon.vue?vue&type=script&lang=js"
import style0 from "./officerComingSoon.vue?vue&type=style&index=0&id=8538b6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8538b6d4",
  null
  
)

export default component.exports